import React from "react";
import ReactDOM from "react-dom";
import TextDetailsReact from "./TextDetails";

const staticSelectInputs = {
  medium_type: {
    labelText: "Referral",
    options: [
      { label: "Organic", value: "organic" },
      { label: "Paid", value: "paid" },
      { label: "Referral", value: "referral" },
      { label: "Other", value: "other" },
      { label: "Direct", value: "direct" },
    ],
  },
};

class TextDetails extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    this.innerHTML = `<div id="root"></div>`;

    this.medium_type =
      this.getAttribute("medium_type") === "" ? "all" : this.getAttribute("medium_type");

    const mediumTypeLabel = staticSelectInputs.medium_type.options.find(
      (option) => option.value === this.medium_type
    )?.label;
    if (this.medium_type === "all") {
      this.medium_type = [];
    } else {
      this.medium_type = [{ label: mediumTypeLabel, value: this.medium_type }];
    }

    ReactDOM.render(
      React.createElement(TextDetailsReact, {
        defaultFiltersFromURL: {
          medium_type: this.medium_type,
        },
        controllerName: this.getAttribute("controller_name"),
        domainId: this.getAttribute("domain_id"),
        selectInputs: staticSelectInputs,
      }),
      this.querySelector("#root")
    );
  }
}

customElements.define("text-details", TextDetails);
